import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { articles } from "../../api";
import { useHistory } from "react-router-dom";
import styles from "./termsAndConditions.module.scss";
import { Breadcrumb } from "antd";

const TermsAndConditions = () => {
  const { t, i18n } = useTranslation(["common"]);
  const [policyVntrip, setPolicyVntrip] = useState<any>("");
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await articles();
        if (res.status === "success") {
          setPolicyVntrip(res.data[2]);
        }
      } catch (e) {
        throw e;
      }
    }
    fetchData();
  }, [i18n.language]);
  return (
    <section className={styles.termOfUse}>
      <div className="container mx-auto">
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <a
              className={styles.breadcrumb__link}
              onClick={() => {
                history.push("/");
              }}
            >
              {t("common:Trang chủ")}
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span className={styles.breadcrumb__active}>
              {t("common:Điều khoản và Điều kiện")}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.termOfUse__body}>
          <h2 className={styles.title}>{policyVntrip.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: policyVntrip.content }} />
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
